<template>
  <v-navigation-drawer absolute v-model="show" width="512"
                       temporary app
                       right>
    <template v-slot:prepend>
      <v-toolbar flat tile extended>
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="fetchTechniques()"><v-icon>mdi-refresh</v-icon></v-btn>
        <v-btn icon @click="show=false"><v-icon>mdi-close</v-icon></v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab">
            <v-tab v-for="v, k, i in settings" :key="i">{{ k }}</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
    </template>

    <v-divider></v-divider>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="v, k in settings" :key="k">
        <v-sheet class="pa-5">
          <template v-for="i in v">
            <v-text-field :dense="i.dense" outlined v-if="[String,Number].includes(i.type) && !i.options" :label="i.title" v-model.number="i.value" :suffix="i.suffix" persistent-hint :hide-details="i.details" />
            <v-radio-group :label="i.title" v-if="[String,Number].includes(i.type) && !!i.options" row v-model="i.value">
              <v-radio v-for="o in i.options" :key="o.name" :label="o|capitalize" :value="o" />
            </v-radio-group>
            <v-checkbox v-if="[Boolean].includes(i.type)" :label="i.title" v-model="i.value" persistent-hint />
            <v-range-slider :label="i.title" v-if="[Object].includes(i.type)" :min="i.min" :max="i.max" :step="i.step" :hint="rangeHint(i)" v-model="i.value" persistent-hint>
              <template v-slot:thumb-label="props">
                {{ props.value }}
              </template>
            </v-range-slider>
          </template>
        </v-sheet>
      </v-tab-item>
    </v-tabs-items>
  </v-navigation-drawer>
</template>
<script>
import Techniques from '@/api/techniques'
import Users from '@/api/users'
export default {
  name: 'Settings',
  data () {
    return {
      show: false,
      tab: null,
      techniques: [],
      settings: {
        'optimized': [
          { name: 'version', title: 'Version of algorithm to use', value: 'original', type: String, options: ['original','advanced'], dense: true, details: false },
          { name: 'iterations', title: 'Number of iterations to remove outliers', value: 0, type: Number, dense: true, details: false },
          { name: 'threshold', title: 'Error threshold to qualify as outlier', value: 0, type: Number, dense: true, details: false },
          { name: 'minimum', title: 'How much of the original data to retain', value: 0, type: Number, dense: true, details: false },
          { name: 'absolute', title: 'Return absolute value Arps parameters', value: false, type: Boolean, dense: true, details: false },
          { name: 'drop_threshold', title: 'Drop or ignore values below this number', value: 0, type: Number, dense: true, details: false },
        ],
        'mmh': [
          { name: 'version', title: 'Version of algorithm to use', value: 'original', type: String, options: ['original'], dense: true, details: false },
          { name: 'iterations', title: 'Number of iterations to remove outliers', value: 0, type: Number, dense: true, details: false },
          { name: 'threshold', title: 'Error threshold to qualify as outlier', value: 0, type: Number, dense: true, details: false },
          { name: 'minimum', title: 'How much of the original data to retain', value: 0, type: Number, dense: true, details: false },
          { name: 'absolute', title: 'Return absolute value Arps parameters', value: false, type: Boolean, dense: true, details: false },
          { name: 'drop_threshold', title: 'Drop or ignore values below this number', value: 0, type: Number, dense: true, details: false },
          { name: 'reanchor', title: 'Match decline to most recent peak', value: false, type: Boolean, dense: true, details: false },
          { name: 'reanchor_min_months', title: 'Minimum number of months to qualify for reanchor', value: 0, type: Number, dense: true, details: false },
          { name: 'reanchor_min_peak_fraction', title: 'Size of peaks to detect', value: 0, type: Number, dense: true, details: false },
          { name: 'reanchor_trim_tail', title: 'Filter influence of unrealistic predictions', value: false, type: Boolean, dense: true, details: false },
          { name: 'reanchor_trim_tail_months', title: 'Number of unrealistic prediction months to cut', value: 0, type: Number, dense: true, details: false },
          { name: 'align_fit', title: 'Align fit with prediction', value: false, type: Boolean, dense: true, details: false },
          { name: 'align_window_months', title: 'Number of recent months to align with', value: 0, type: Number, dense: true, details: false },
        ],
        'automatic': [
          { name: 'version', title: 'Version of algorithm to use', value: 'original', type: String, options: ['original','advanced'], dense: true, details: false },
          { name: 'Q', title: 'Fit qi between ', value: [0,0], type: Object, min: 0, max: 1, step: 0.1, dense: true, details: false },
          { name: 'D', title: 'Fit Di between', value: [0,0], type: Object, min: 0, max: 2, step: 0.1, dense: true, details: false },
          { name: 'B', title: 'Fit b between', value: [0,0], type: Object, min: 0, max: 1.5, step: 0.1, dense: true, details: false },
        ]
      }
    }
  },
  mounted() {
    this.fetchTechniques()
  },
  watch: {
    show: function(val) {
      if (val) {
        this.techniques.forEach(technique => {
          if (!!this.user.session) {
            if (technique in this.user.session) {
              Object.entries(this.user.session[technique]).forEach(([key, value]) => {
                this.settings[technique].find(x => x.name == key).value = value
              })
            }
          }
        });
      } else {
        Users.patch(this.user.username, { 'session': this.userSettings }).then(_ => {
          this.user.session = this.userSettings
        })
      }
    }
  },
  computed: {
    userSettings() {
      let out = {}
      this.techniques.forEach(technique => {
        let dump = JSON.parse(JSON.stringify(this.settings[technique]))
        dump = dump.reduce((a, i) => { a[i.name] = i.value; return a}, {})
        out[technique] = dump
      })
      return out
    }
  },
  methods: {
    fetchTechniques() {
      Techniques.list().then(response => {
        response.data.forEach(technique => {
          this.techniques.push(technique.slug)
          this.settings[technique.slug].forEach(item => {
            item.value = technique.config[item.name]
          })
        });
      })
    },
    rangeHint(i) {
      return `[${i.value[0]}, ${i.value[1]}]`
    }
  }
}
</script>
